import { groupEntries } from "@/mocks/gossip";

export default function GroupEntry() {
  return (
    <section id="group" className="w-full scroll-mt-20 bg-secondary-900 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-secondary-200">
              <i className="ri-group-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              吃瓜群
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-background-50">吃瓜群入口 · 实时跟上群里的节奏</h2>
            <p className="mt-2 max-w-2xl text-sm text-secondary-100/85">
              论坛适合慢慢翻帖，吃瓜群则适合即时讨论。以下是当前开放的群组方向，按兴趣选择即可。
              所有群组均为兴趣交流群，不收取任何费用，入群后请先阅读置顶规则。
            </p>
          </div>
          <div className="rounded-lg border border-secondary-700 bg-secondary-800/60 px-4 py-3 text-secondary-100">
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-accent-300" aria-hidden="true"></i>
              群内文明交流 · 拒绝广告与人身攻击
            </div>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {groupEntries.map((group) => (
            <div key={group.name} className="flex flex-col rounded-lg border border-secondary-700 bg-secondary-800/50 p-5">
              <div className="flex items-center justify-between">
                <span className="flex items-center justify-center w-11 h-11 rounded-md bg-secondary-700 text-secondary-50">
                  <i className={`${group.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="rounded-full bg-secondary-700 px-3 py-1 text-xs text-secondary-100">{group.members}</span>
              </div>
              <h3 className="mt-4 text-base font-medium text-background-50">{group.name}</h3>
              <p className="mt-2 flex-1 text-xs leading-relaxed text-secondary-100/80">{group.desc}</p>
              <div className="mt-4 flex items-center gap-1.5 border-t border-secondary-700 pt-3 text-xs text-accent-300">
                <i className="ri-information-line w-3.5 h-3.5 flex items-center justify-center" aria-hidden="true"></i>
                {group.note}
              </div>
            </div>
          ))}
        </div>

        <p className="mt-6 text-xs text-secondary-200/70">
          * 本页仅展示群组方向与入口说明，不提供在线申请表单；具体加入方式以站内公告为准。
        </p>
      </div>
    </section>
  );
}